import React, { createRoot } from 'react-dom/client';
import TerritoryShowPage from '../javascripts/territory/Show';
import ItemsIndexPage from '../javascripts/items/IndexPage';
import PhotoRow from './items/IndexPage/PhotoRow';
import UserGroupTerritorySelect from './userGroup/TerritorySelect';
import ContactsIndexPage from '../javascripts/contacts/IndexPage';
import UserDevicesIndexPage from '../javascripts/userDevices/IndexPage';
import VehiclesIndexPage from '../javascripts/vehicles/IndexPage';

function render() {
  const contactsIndexPage = document.getElementById('contacts-index-page');
  if (contactsIndexPage) {
    const data = JSON.parse(contactsIndexPage.getAttribute('data-contacts'));
    const root = createRoot(contactsIndexPage);
    root.render(<ContactsIndexPage data={data} />);
  }

  const userDevicesIndexPage = document.getElementById('user-devices-index-page');
  if (userDevicesIndexPage) {
    const data = JSON.parse(userDevicesIndexPage.getAttribute('data-user-devices'));
    const root = createRoot(userDevicesIndexPage);
    root.render(<UserDevicesIndexPage data={data} />);
  }

  const vehiclesIndexPage = document.getElementById('vehicles-index-page');
  if (vehiclesIndexPage) {
    const data = JSON.parse(vehiclesIndexPage.getAttribute('data-vehicles'));
    const root = createRoot(vehiclesIndexPage);
    root.render(<VehiclesIndexPage initialData={data} />);
  }


  const a = document.getElementById('territory-show-page');
  if (a) {
    const id = a.getAttribute('data-territory-id')
    const name = a.getAttribute('data-territory-name')
    const root = createRoot(a);
    root.render(<TerritoryShowPage id={id} name={name} />);
  }

  const b = document.getElementById('items-index-page');
  if (b) {
    const root = createRoot(b);
    root.render(<ItemsIndexPage />);
  }

  const photoRows = document.getElementsByClassName('vehicle-photos-td');
  if (photoRows?.length) {
    for (let e of photoRows) {
      const before_images = JSON.parse(e.getAttribute('data-before-images'));
      const after_images = JSON.parse(e.getAttribute('data-after-images'));
      const root = createRoot(e);
      root.render(
        <PhotoRow
          before_images={before_images}
          after_images={after_images}
        />
      );
    }
  }

  const userGroupTerritorySelect = document.getElementById('user-group-territory-select');
  if (userGroupTerritorySelect) {
    const userGroupTerritories = userGroupTerritorySelect.getAttribute('data-user-group-territories')
    const options = userGroupTerritorySelect.getAttribute('data-options')
    const root = createRoot(userGroupTerritorySelect);
    root.render(<UserGroupTerritorySelect userGroupTerritories={userGroupTerritories} options={options} />);
  }
}

document.addEventListener('turbolinks:load', () => {
  render()
});